import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getInvoices({ commit }, { filters }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query (
        $invoice_type: String
        $invoice_numbers: [String]
        $date_range_type: String
        $logistic_providers: [Int]
        $date_range: DateRangeInput
        $search_by: String!
        $search_values: [String]
      ) {
        invoices (
          invoice_type: $invoice_type
          invoice_numbers: $invoice_numbers
          date_range_type: $date_range_type
          logistic_providers: $logistic_providers
          date_range: $date_range
          search_by: $search_by
          search_values: $search_values
        ) {
          id
          invoice_type
          logistic_provider
          generation_date
          expiration_date
          invoice_count
          invoice_value
          user
        }
      }`, filters)
      .then(({ data }) => {
        const { invoices = [] } = data || {};

        commit('setInvoices', invoices);
        commit('toggleLoading', false);
      })
      .catch(() => commit('toggleLoading', false));
  },

  exportToExcel({ commit, state }, filters) {
    commit('toggleLoadingExports', true);

    return GraphQlClient.query(`
      query (
        $invoice_type: String!
        $date_range_type: String
        $logistic_providers: [Int]
        $date_range: DateRangeInput!
        $search_by: String!
        $search_values: [String]
      ) {
        exportInvoices (
          invoice_type: $invoice_type
          logistic_providers: $logistic_providers
          date_range: $date_range
          date_range_type: $date_range_type
          search_by: $search_by
          search_values: $search_values
        ) {
          ok
        }
      }`, filters)
      .then(() => commit('toggleLoadingExports', false))
      .catch(() => commit('toggleLoadingExports', false));
  },

  sendInvoiceMirror({ commit }, filters) {
    commit('toggleLoadingInvoice', true);

    return GraphQlClient.query(`
      query (
        $invoice_type: String!
        $date_range_type: String
        $logistic_providers: [Int]
        $date_range: DateRangeInput!
        $search_by: String!
        $search_values: [String]
      ) {
        invoiceMirror (
          invoice_type: $invoice_type
          logistic_providers: $logistic_providers
          date_range: $date_range
          date_range_type: $date_range_type
          search_by: $search_by
          search_values: $search_values
        ) {
          ok
        }
      }`, filters)
      .then(() => commit('toggleLoadingInvoice', false))
      .catch(() => commit('toggleLoadingInvoice', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/invoice/store/actions.js